import { AxiosRequestConfig } from "axios";
import {
    NO_OP,
    AuthConfig,
    Authenticator
} from './auth'
import { equals } from "ramda";



class NoopAuth implements Authenticator {

    auth: AuthConfig;

    constructor(auth: AuthConfig) {
        this.auth = auth;
    }

    public isAuthProvider(): boolean {
        return equals(this.auth.provider, NO_OP)
    }

    public applyAuthentication(config: AxiosRequestConfig): AxiosRequestConfig {
        return config
    }

    public shouldRefresh() {
        return false
    }

    public refreshAuthentication() {
        // Update session with latest token 
        return Promise.resolve()
    }
};

export {
    NoopAuth
};